import { getUser, isUserLogin } from '@/util'
import { env } from '@/config'

// 初始化
const _initTracker = () => {
  try {
    // const userData = getUser()
    // const userId = userData.user?.id
    // // 阿里云埋点mpaas配置
    // window._to = {
    //   // pre-mdap.mpaas.cn-hangzhou.aliyuncs.com，预发
    //   // mdap.mpaas.cn-hangzhou.aliyuncs.com，线上
    //   // 必填，接受埋点的服务地址
    //   server: `https://cn-hangzhou-mas-log.cloud.alipay.com/loggw/webLog.do`,
    //   appId: 'ALIPUB50A7CFC131009', // 必填，App 唯一标识
    //   workspaceId: `H5${env}`, // 必填，环境标识
    //   h5version: `1.0.0`,    // 必填，客户端 App/H5 页面版本
    //   mtrDebug: env !== 'prod',         // 选填，默认为 false
    //   userId: userId,
    // }
    // window.initTracker && window.initTracker()
    //
  } catch (error) {
    console.log(error)
  }
}

// 记录网页页面内某段内容的曝光情况。
const quick = (...param) => {
  try {
    // window.Tracker && param && window.Tracker.expo(...param)
  } catch (error) {
    console.log(error)
  }
}

// 自定义事件
/** string {trackName} */
/** object {trackData} */
const track = (...param ) => {
  try {
    // const _timer = setTimeout(() => {
    //   window.Tracker && param && window.Tracker.click(...param)
    //   clearTimeout(_timer)
    // }, 0)
  } catch (error) {
    console.log(error)
  }
}
// sensors.track('BuyProduct', {
// 	ProductName: "MacBook Pro",
// 	ProductPrice: 123.45,
// 	IsAddedToFav: false,
// });

// 当用户注册成功或者登录成功时，需要调用 login() 方法传入登录 ID：
const login = (param) => {
  try {
    if ( window._to ) {
      // window._to.userId = param
      // window.initTracker && window.initTracker()
    }
  } catch (error) {
    console.log(error)
  }
}
// process.env.NODE_ENV
// 神策数据初始化并自动采集page事件。
const autoTrackAndInit = () => {

  _initTracker()

}

const getLoginSendUserId = (id) => {
  const userData = getUser()
  const userId = id || userData.user?.id
  if ( isUserLogin() || id !== undefined ) {
    // login(userId)
  } else {
    // login('0')
  }
}


export default {
  quick,
  track,
  login,
  autoTrackAndInit,
  getLoginSendUserId,
}